import RootContainer from './root_container';

const Root = RootContainer;

export default Root;
